import React from 'react';
import IsibetHorseTicketHeader from '../third-party-ticket/IsibetHorseTicketHeader';
import IsibetHorseTicketSelections from '../third-party-ticket/IsibetHorseTicketSelections';
import IsibetHorseTicketFooter from '../third-party-ticket/IsibetHorseTicketFooter';

function IsibetHorseTicket(props) {
	
	const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration
	const isCashout = props.isCashout;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const user = props.user;
	const conf = props.conf;
	const skinProperties = props.skinProperties;
	
	return <>
	<div id={"ticket-" + ticketData.idTicket} className="ticket-container">
		<IsibetHorseTicketHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<IsibetHorseTicketSelections conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<IsibetHorseTicketFooter  conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />	
	</div>
	</>
}

export default IsibetHorseTicket;